import { observable } from 'mobx'
import { asNumber } from '@taxfyle/web-commons/lib/utils/numberUtil'

export default class TxfConfigViewModel {
  @observable
  txfStripeCustomerId = undefined

  @observable
  autoVerificationConfig = 'SKIP_WHEN_POSSIBLE'

  @observable
  totalCredits = undefined

  @observable
  walletEnabled = false

  activate(
    txfStripeCustomerId = undefined,
    autoVerificationConfig = 'SKIP_WHEN_POSSIBLE',
    totalCredits = undefined,
    creditSource = undefined
  ) {
    this.txfStripeCustomerId = txfStripeCustomerId
    this.autoVerificationConfig = autoVerificationConfig
    this.totalCredits = totalCredits
    this.walletEnabled = creditSource === 'WALLET'
  }

  toJSON() {
    return {
      stripe_customer_id: this.txfStripeCustomerId,
      auto_verification_config: this.autoVerificationConfig,
      ...(this.walletEnabled && { credit_source: 'WALLET' }),
      // A self-serve wallet never had a total, and coercing blank to 0 would write one.
      ...(this.totalCredits != null &&
        this.totalCredits !== '' && {
          total_credits: asNumber(this.totalCredits),
        }),
    }
  }
}
